angular
    .module('quattro.bmbo.account.list', [
        'quattro.bmbo.account.modal-edit',
        // 'quattro.bmbo.account.modal-add',
    ])
    .directive('bmboAccountList', function () {
        return {
            scope: {
                list: '=',
                reload: '=',
            },
            templateUrl: 'bmbo/account/accountlist.html',
            controller: 'bmboAccountListController',
            controllerAs: 'vm',
        };
    })
    .controller('bmboAccountListController', function ($scope) {


        // triger modal edits

        this.modalEdit = function (account) {
            $scope.$emit('vq.bmbo.account.edit', account);
        };


        // checkbox selection

        this.selected = function () {
            var list = $scope.list;
            var filtered = list.filter(function (item) {
                return item.$checked;
            });
            return filtered.length ? filtered : list;
        };


        // sorting, filter

        this.search = {};

        this.orderByExpression = 'account';
        this.orderByReverse = false;

        this.orderBy = function (predicate) {
            this.orderByReverse = (this.orderByExpression === predicate) ? !this.orderByReverse : false;
            this.orderByExpression = predicate;
        };
        this.orderedClass = function (predicate) {
            if (this.orderByExpression === predicate) {
                return this.orderByReverse ? 'sort-desc' : 'sort-asc';
            }
            return '';
        };

    });
